import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { PayrollSchedule } from '../../onboarding/classes/payroll-schedule';

@Injectable()
export class PayrollScheduleService {

  constructor(private http: Http) { }

  getPayrollschedule(orgId: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.get(`${environment.organizationsUrl}${orgId}/${environment.payrollSchedulesUrl}`, options)
      .map(res => res.json())
  }

  addPayrollSchedule(orgId: number, info: PayrollSchedule) {
    let data = { payroll_schedule: info, commit: 'Add', organization_id: orgId };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.post(`${environment.organizationsUrl}${orgId}/${environment.payrollSchedulesUrl}`, data, options)
      .map(res => res.json())
  }

  editPayrollSchedule(orgId: number, id: number, info: PayrollSchedule) {
    let data = { payroll_schedule: info, commit: 'Add', organization_id: orgId, id };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.patch(`${environment.organizationsUrl}${orgId}/organization_setups/payroll_schedules/${id}.json`, data, options)
      .map(res => res.json())
  }

  deletePayrollSchedule(orgId: number, id: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.delete(`${environment.organizationsUrl}${orgId}/organization_setups/payroll_schedules/${id}.json`, options)
      .map(res => res.json())
  }
}



// WEBPACK FOOTER //
// ./src/app/onboarding/services/payroll-schedule.service.ts